import axios from 'axios';

const api = axios.create({ baseURL: '/api', withCredentials: true }); // withCredentials sends httpOnly cookie as backup auth

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('flowup_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response?.status === 401) {
      const onLogin = window.location.pathname === '/login';
      const isLoginCall = err.config?.url?.includes('/auth/login') || err.config?.url?.includes('/auth/me');
      if (!onLogin && !isLoginCall) {
        localStorage.removeItem('flowup_token');
        sessionStorage.setItem('session_expired', '1');
        // Dispatch event so React can handle gracefully instead of hard reload
        window.dispatchEvent(new CustomEvent('auth:logout'));
        // Fallback hard redirect after a tick (React should catch first)
        setTimeout(() => { window.location.replace('/login'); }, 100);
      }
    }
    return Promise.reject(err.response?.data || { error: err.message });
  }
);

// Convenience methods
api.get = (url, config) => api({ method: 'get', url, ...config });
api.post = (url, data, config) => api({ method: 'post', url, data, ...config });
api.put = (url, data, config) => api({ method: 'put', url, data, ...config });
api.delete = (url, config) => api({ method: 'delete', url, ...config });

export default api;
